import React, { FC } from "react";
import { Flex, ScrollArea } from "@mantine/core";

interface ChatContainerProps {
  children: React.ReactNode;
  viewport: React.RefObject<HTMLDivElement>;
  checkScroll: () => void;
}

const ChatContainer: FC<ChatContainerProps> = ({
  children,
  viewport,
  checkScroll,
}) => {
  return (
    <ScrollArea
      overscrollBehavior="contain"
      viewportRef={viewport}
      h="100%"
      w="100%"
      classNames={{ viewport: "custom-viewport" }}
      onScrollPositionChange={checkScroll}
    >
      <Flex direction="column" gap="sm" h="100%" w="100%">
        {children}
      </Flex>
    </ScrollArea>
  );
};

export default ChatContainer;
